import { Outlet } from "react-router";
import Header from "../components/Header";
import { styles } from "../theme/styles";

function Layout() {
  return (
    <div style={{ ...styles.main}}>
      <Header />
      <Outlet />
    </div>
  );
}

export default Layout;
